"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissionLevelDisplayNames = void 0;
var react_1 = require("react");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var usePermissionObject_1 = require("./usePermissionObject");
function usePermissionLevelDisplayNames() {
    var _js = (0, usePermissionsModalContext_1.usePermissionsModalContext)()._js;
    var objectType = (0, usePermissionObject_1.usePermissionObject)().objectType;
    var permissionLevelToDisplayName = (0, react_1.useMemo)(function () {
        if (objectType === 'workspaces') {
            return {
                view: _js('Member'),
                edit: _js('Author'),
                comment: _js('Commenter'),
                assign: _js('Course Assigner'),
                manage: _js('Admin'),
                none: _js('Remove Permissions'),
            };
        }
        return {
            view: _js('Can View'),
            edit: _js('Can Edit'),
            comment: _js('Can Comment'),
            assign: _js('Can Assign'),
            manage: _js('Can Manage'),
            none: _js('Remove Permissions'),
        };
    }, [_js, objectType]);
    return permissionLevelToDisplayName;
}
exports.usePermissionLevelDisplayNames = usePermissionLevelDisplayNames;
